import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-dropdown',
  templateUrl: './ui-dropdown.component.html',
  styleUrls: ['./ui-dropdown.component.css']
})
export class UiDropdownComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
